export default __webpack_public_path__ + "static/media/img3.a3d519bf.jpg";